import React from 'react'
import PageTitle from './include/PageTitle'
import { useI18n } from '../i18n/I18nContext'
import { Link } from 'react-router-dom'
import { getServicesPageCopy } from '../content/localeCopy'
import { useTranslatedCopy } from '../i18n/useTranslatedCopy'
import Seo, { ARABIC_SEO_KEYWORDS, ENGLISH_SEO_KEYWORDS, buildServicesHubStructuredData, mergeSeoKeywords } from '../Components/Seo'

const serviceCardVisuals = {
  "Property Management": {
    icon: "flaticon-house",
    
  },
  "Real Estate Brokerage": {
    icon: "flaticon-mortgage",
    
  },
  "Real Estate Marketing": {
    icon: "flaticon-operator",
   
  },
  "Maintenance & Operations": {
    icon: "flaticon-house-1",
    
  },
  "Property Development": {
    icon: "flaticon-building",
   
  },
}

const servicesSeoEntries = [
  { name: "Property Management", path: "/property-management-saudi-arabia" },
  { name: "Real Estate Brokerage", path: "/real-estate-brokerage-saudi-arabia" },
  { name: "Real Estate Marketing", path: "/real-estate-marketing-saudi-arabia" },
  { name: "Maintenance & Operations", path: "/property-maintenance-operations-saudi-arabia" },
  { name: "Property Development", path: "/property-development-saudi-arabia" },
]

const Services = () => {
  const { t, locale } = useI18n()
  const copy = useTranslatedCopy(getServicesPageCopy(), locale)
  const servicesAboutImage = `${process.env.PUBLIC_URL || ""}/img/service/Gemini_Generated_Image_lchs6blchs6blchs.png`
  return (
    <div>
      <Seo
        title="QTECH Real Estate Services in Saudi Arabia | Property Management, Brokerage, Marketing, Development"
        titleAr="خدمات عقارية في السعودية والخبر | شركة تقنيات الجودة"
        description="Explore QTECH real estate services in Saudi Arabia and Al Khobar, including property management, brokerage, real estate marketing, maintenance and operations, and property development."
        descriptionAr="اكتشف خدمات شركة تقنيات الجودة العقارية في السعودية والخبر، وتشمل إدارة الأملاك، الوساطة العقارية، التسويق العقاري، صيانة المباني، والتطوير العقاري."
        keywords={mergeSeoKeywords(
          ENGLISH_SEO_KEYWORDS.services,
          "real estate investment Saudi Arabia, property investment services Saudi Arabia, investment property advisory Saudi Arabia, real estate investment opportunities Al Khobar, Saudi Arabia property investors"
        )}
        keywordsAr={mergeSeoKeywords(
          ARABIC_SEO_KEYWORDS.services,
          "استثمار عقاري, خدمات استثمار عقاري, فرص استثمار عقاري في السعودية, استثمار عقاري في الخبر, مستثمرين عقاريين, عقارات استثمارية, خدمات عقارية للمستثمرين"
        )}
        path="/services"
        image="/img/service/services-about-meeting-vertical.png"
        structuredData={buildServicesHubStructuredData(servicesSeoEntries)}
      />
      <PageTitle titleKey="pages.services.title" currentPageKey="pages.services.title" bgImage="/img/bg/14.jpg" />


      <div className="ltn__about-us-area pb-115">
        <div className="container">
          <div className="row qtech-services-about-row">
            <div className="col-lg-5 qtech-services-about-media">
              <div className="about-us-img-wrap ltn__img-shape-left about-img-left services-about-image-wrap">
                <img
                  className="services-about-image"
                  src={servicesAboutImage}
                  alt="About QTECH Services"
                />
              </div>
            </div>
            <div className="col-lg-7 qtech-services-about-content">
              <div className="about-us-info-wrap">
                <div className="section-title-area ltn__section-title-2--- mb-20">
                  <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">
                  {copy.aboutSubtitle}
                  </h6>
                  <h1 className="section-title">
                    {copy.heading}<span>.</span>
                  </h1>
                  <p>{copy.paragraphs[0]}</p>
                  <p className="mt-4">{copy.paragraphs[1]}</p>
                </div>
                <div className="btn-wrapper animated">
                  <a
                    href="/about"
                    className="theme-btn-1 btn btn-effect-1 text-uppercase"
                  >
                    {copy.button}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="ltn__service-area section-bg-1 pt-115 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2--- text-center">
                <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">
                  {copy.coreSubtitle}
                </h6>
                <h1 className="section-title">{copy.coreTitle}</h1>
              </div>
            </div>
          </div>
          <div className="row justify-content-center gy-4">
            {copy.cards.map((card, index) => {
              const fallbackVisuals = Object.values(serviceCardVisuals)[index] || {}
              const visuals = serviceCardVisuals[card.title] || fallbackVisuals

              return (
              <div className="col-lg-4 col-sm-6 col-12 d-flex" key={card.title}>
                <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white box-shadow-1 h-100 w-100 d-flex flex-column">
                  <div style={{ width: "100%", marginBottom: "18px" }}>
                     
                  </div>
                  <div className="ltn__feature-icon">
                    <span>
                      <i className={visuals.icon || "flaticon-house"} />
                    </span>
                  </div>
                  <div className="ltn__feature-info">
                    <h3 className="animated fadeIn">
                      <Link to={card.href}>{card.title}</Link>
                    </h3>
                    <p>{card.body}</p>
                  </div>
                </div>
              </div>
            )})}
          </div>
        </div>
      </div>





    </div>
  )
}

export default Services
